import React, { Component } from 'react';
import { Button, Row, Col, Input } from 'reactstrap';
import { data_change_status, status_change_action, formatDate, funLogout } from "./globalFunction/response_action";
import './TotalCss.css'
import './FetchData.css';
import { api_url } from "./globalFunction/global_string";
import Swal from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function mapOpcallityToText(opcallity) {
  const level = {
    3: '高',
    2: '中',
    1: '普'
  };
  return level[opcallity] || '未知';
}

export class FetchDataExcel extends Component {
  static displayName = FetchDataExcel.name;


  constructor(props) {
    super(props);
    this.state = {
      fetchDataForTableExcel: props.fetchDataForTableExcel,
      isFetchDataExcel: props.isFetchDataExcel,
      forecasts: [],
      filteredForecasts: [],
      filterText: '',
      loading: true,
      sortColumn: null,
      editingId: null,
      columnSort: { url_addr: 'asc', unit_name: 'asc', build_id: 'asc', build_date: 'asc' }
    };
  }

  componentDidMount() {
    this.populateWeatherData();
  }


  componentDidUpdate(prevProps) {
    // console.log(prevProps)
    if (
      this.props.isFetchDataExcel !== prevProps.isFetchDataExcel ||
      this.props.selectnet !== prevProps.selectnet ||
      this.props.selectedUnitproxy !== prevProps.selectedUnitproxy ||
      this.props.selectedUnit !== prevProps.selectedUnit
    ) {
      this.populateWeatherData();
    }
  }

  handleEdit(id) {
    this.setState({ editingId: id });
  }

  handleSave = (id) => {
    const forecast = this.state.forecasts.find(f => f.id === id);
    if (forecast) {
      let apiUrl = api_url + '/api/JRCC/PutLocalUrlId';
      const formData = new FormData();
      formData.append("id", id);
      formData.append("url_name", forecast.url_name);
      formData.append("url_addr", forecast.url_addr);
      formData.append("user_id", this.state.fetchDataForTableExcel.user_id);
      formData.append("local_net_id", this.state.fetchDataForTableExcel.local_net_id);
      formData.append("user_type", this.state.fetchDataForTableExcel.current_user_type);
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Authorization": localStorage.getItem('accessToken')
        },
        body: formData
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            console.error('Error parsing JSON:', error);
            throw error;
          };
        })
        .then(data => {
          let arr_status = [String(data.statusCode), data.row, data.detail];
          switch (arr_status[0]) {
            case "200":
              Swal.fire({
                icon: 'success',
                title: '【修改成功】',
                text: '恭喜'
              });
              this.populateWeatherData();
              break;
            case "400":
              Swal.fire({
                icon: 'error',
                title: `${data.row}`,
                text: '請聯絡管理員'
              });
              this.populateWeatherData();
              break;
            default:
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
      this.setState({ editingId: null });
    }
  }

  handleFilterChange = (e) => {
    const { forecasts } = this.state;
    const filterText = e.target.value;

    const filteredForecasts = filterText ? forecasts.filter((item) => {
      const searchString = `${item.local_unit_name} ${item.url_name} ${item.url_addr} ${mapOpcallityToText(item.opcallity)} ${item.build_id} ${item.build_date}`.toLowerCase();
      return searchString.includes(filterText.toLowerCase());
    }) : forecasts;

    this.setState({ filterText, filteredForecasts });
  };
  // 
  handleInputChange = (event, id, field) => {
    const value = event.target.value;
    this.setState((prevState) => {
      // 更新 forecasts
      const updatedForecasts = prevState.forecasts.map((forecast) => {
        if (forecast.id === id) {
          return { ...forecast, [field]: value };
        }
        return forecast;
      });

      // 更新 filteredForecasts
      const updatedFilteredForecasts = prevState.filteredForecasts.map((forecast) => {
        if (forecast.id === id) {
          return { ...forecast, [field]: value };
        }
        return forecast;
      });

      return {
        forecasts: updatedForecasts,
        filteredForecasts: updatedFilteredForecasts
      };
    });
  };

  //刪除
  handleDelete(id) {
    Swal.fire({
      title: '您確定要刪除嗎？',
      text: "此操作無法撤銷！",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '是的，刪除它！',
      cancelButtonText: '取消'
    }).then((result) => {
      if (result.isConfirmed) {
        let apiUrl = api_url + '/api/JRCC/DeleteLocalUrlId';
        const formData = new FormData();
        formData.append('id', id)

        fetch(apiUrl, {
          method: "POST",
          headers: {
            "Authorization": localStorage.getItem('accessToken'),
          },
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            if (data.statusCode === 200) {
              Swal.fire({
                icon: 'success',
                title: '【刪除成功】',
                text: '已成功刪除'
              });
              this.populateWeatherData();
            } else {
              Swal.fire({
                icon: 'error',
                title: '【刪除失敗】',
                text: '請聯絡管理員'
              });
            }
          })
          .catch(error => {
            console.error('Error:', error);
            Swal.fire({
              icon: 'error',
              title: '【刪除失敗】',
              text: '請聯絡管理員'
            });
          });
      }
    })
  }

  render() {
    const { forecasts, fetchDataForTableExcel: { user_id: currentUserId }, editingId, filteredForecasts, filterText } = this.state;

    const columns = [
      {
        name: '單位',
        selector: row => row.local_unit_name,
        cell: row => <div className="Research-wrap">{row.local_unit_name}</div>,
        sortable: true,
      },
      {
        name: '網站名',
        selector: row => row.url_name,
        sortable: false,
        cell: row => (
          editingId === row.id ? (
            <input
              style={{ width: '250px' }}
              type="text"
              value={row.url_name}
              onChange={(e) => this.handleInputChange(e, row.id, 'url_name')}
            />
          ) : (
            <a href={row.url_addr}>{row.url_name}</a>
          )
        ),
      },
      {
        name: '網站網址',
        selector: row => row.url_addr,
        sortable: false,
        cell: row => (
          <div style={{ width: '400px' }}>
            {row.url_addr}
          </div>
        )
      },
      {
        name: '重要性',
        selector: row => row.opcallity,
        sortable: true,
        cell: row => (
          <div style={{ width: '50px', textAlign: 'center' }}>
            {mapOpcallityToText(row.opcallity)}
          </div>
        ),
      },
      {
        name: '建立人員',
        selector: row => row.build_id,
        sortable: true,
      },
      {
        name: '建立時間',
        selector: row => row.build_date,
        sortable: true,
      },
      {
        name: '操作',
        cell: row => (
          <>
            {currentUserId === row.build_id && (
              <>
                {editingId === row.id ? (
                  <Button onClick={() => this.handleSave(row.id)}>儲存</Button>
                ) : (
                  <Button onClick={() => this.handleEdit(row.id)}>編輯</Button>
                )}
                <Button onClick={() => this.handleDelete(row.id)}>刪除</Button>
              </>
            )}
          </>
        ),
      },
    ];
    if (this.state.fetchDataForTableExcel.current_user_type === 'S') {
      columns.splice(0, 0, {
        name: '區網',
        selector: row => row.local_net_name,
        cell: row => <div className="Research-wrap">{row.local_net_name}</div>,
        sortable: true,
      });
    }

    return (
      <DataTable
        columns={columns}
        data={filteredForecasts}
        pagination
        paginationPerPage={20}
        subHeader
        subHeaderComponent={
          <div className="row justify-content-end">
            <div className="col-md-4 input-group">
              <div className="input-group-prepend bg-info">
                <span className="input-group-text bg-info" style={{ borderTopLeftRadius: '0.7rem', borderBottomLeftRadius: '0.7rem' }}>
                  <FontAwesomeIcon icon={faSearch} color="white" />
                </span>
              </div>
              <Input
                type="text"
                placeholder="篩選-請輸入文字..."
                value={filterText}
                onChange={this.handleFilterChange}
                className="form-control"
              />
            </div>
          </div>
        }
        customStyles={{
          headRow: {
            style: { background: 'transparent' },
          },
          headCells: {
            style: { fontSize: '14px', fontWeight: 'bold' },
          },
        }}
        customFilterText={filterText}
        onFilter={(e) => this.customFilter(e)}
      />
    );
  }


  async populateWeatherData() {
    const { current_user_type, local_net_id, local_unit_id, selectedUnit, user_id } = this.state.fetchDataForTableExcel;

    const formData = new FormData();
    formData.append("current_user_type", current_user_type);
    if (current_user_type === "S") {
      if (this.props.selectnet !== undefined) {
        formData.append("local_net_id", local_net_id);
      }
      if (this.props.selectedUnitproxy !== undefined) {
        formData.append("local_unit_id", local_unit_id);
      }
    }


    if (current_user_type === "M") {
      if (this.props.selectedUnit === undefined) {
        formData.append("local_net_id", local_net_id);
      } else {
        formData.append("local_unit_id", this.props.selectedUnit);
        formData.append("local_net_id", local_net_id);
      }

    }
    if (current_user_type === "N") {
      formData.append("local_unit_id", local_unit_id);
      formData.append("local_net_id", local_net_id);
    }
    formData.append("local_unit_id", local_unit_id);
    formData.append("local_net_id", local_net_id);
    formData.append("user_id", user_id);

    //console.log("fetchNameBeforeFetch:", this.state);
    // 發起 AJAX 請求，並將回應的資料更新至狀態中的 options
    await fetch(this.state.fetchDataForTableExcel.fetchDataExcelApi, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        // console.log(data)
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        this.setState({ forecasts: rows, filteredForecasts: rows, loading: false });
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }
}
